// Central brand & integration configuration
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// WhatsApp number (international format, no +)
// TODO: PLACEHOLDER — replace with your real WhatsApp number when ready to connect.
export const WHATSAPP_NUMBER = "918700750247";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const COMPANY = {
  name: "Digitify My Biz",
  tagline: "Meta Ads to Closings — on Autopilot",
  email: "info@digitifymybiz.com",
  phoneDisplay: "WhatsApp us",
  logo:
    "https://static.prod-images.emergentagent.com/jobs/ab9a2288-03d7-4487-a34d-9cf689607406/images/c03beee6589ca5b37cc73fbf8ff40f00cf1323131ac4cd58e461bb22e8871ac2.png",
  logoFull: "/logo.png?v=2",
  address: "Noida, India",
};

// Products — separate checkout links per product (placeholder until provided)
export const PRODUCTS = [
  {
    id: "ai-ads-prompts",
    name: "AI Ads Creative Prompts for Real Estate",
    price: "₹1,999",
    oldPrice: "₹2,999",
    badge: "Best Seller",
    tagline: "100+ AI prompts for winning property ads.",
    description: "Create High-Converting Ads with AI",
    features: ["120+ editable templates", "Listing & sold post packs", "Story + Reels covers", "Lifetime updates"],
    image:
      "https://images.unsplash.com/photo-1562145259-610b3d3ca6ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    checkout: "https://superprofile.bio/digitifymybiz/wcduYWEvvk",
  },
  {
    id: "meta-ads-lead-kit",
    name: "Meta Ads Lead Generation Kit",
    price: "₹999",
    oldPrice: "₹1,999",
    badge: "Proven Framework",
    tagline: "A Proven System to Generate & Convert Property Leads",
    description: "Step-by-step Meta Ads conversion and WhatsApp Automation funnel.",
    features: ["50+ proven scripts", "Qualification flows", "Objection handlers", "Follow-up sequences"],
    image:
      "https://images.pexels.com/photos/8533353/pexels-photo-8533353.jpeg?auto=compress&cs=tinysrgb&w=1100",
    checkout: "https://superprofile.bio/digitifymybiz/qvLrMdvqJg",
  },
  {
    id: "luxury-brokers-playbook",
    name: "The Luxury Real Estate Broker's Playbook",
    price: "₹299",
    oldPrice: "₹999",
    badge: "Luxury Agent's Choice",
    tagline: "Win High-Net-Worth Clients with Confidence.",
    description:
      "The Luxury Real Estate Broker's Playbook is NOT a theoretical guide. It is a battle-tested, technical operating manual designed by Digitify My Biz.",
    features: ["Full campaign blueprints", "Funnel templates", "CRM setup guide", "90-day action plan"],
    image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100",
    checkout: "https://superprofile.bio/digitifymybiz/uuICQUbFrD",
  },
];
